<template>
    <div class="bla-container">
        <Layout type="BLA" name="ICP许可证">
            <product-buy slot="buy" :baseInfo="baseInfo" type="bla" @buy="onBuy" @ask="onAsk">
            <div class="form-data-container" slot="form">
                <div class="form-item">
                <div class="form-label">办理地区：</div>
                <div class="form-content">
                    <div class="form-select">
                    <div class="input-container">
                        <input type="text" placeholder="请选择" readonly autocomplete="on"
                        :value="selectItem.text"
                        @click="onInputClick"/>
                        <img class="input-suffix" src="../assets/sanjiao.png">
                    </div>
                    <ul class="select-container" v-if="selectListShow">
                        <li v-for="(item, index) in regionData" :key="index"
                        :class="[item.value === selectItem.value ? 'li-selected' : '']"
                        @click="onSelectRegion(item)">{{item.text}}</li>
                    </ul>
                    </div>
                </div>
                </div>
                <div class="form-item">
                <div class="form-label">服务特点：</div>
                <div class="form-content">
                    <ul class="form-list">
                    <li v-for="(item, index) in baseInfo.serviceAdvantage" :key="index">{{item}}</li>
                    </ul>
                </div>
                </div>
            </div>
            </product-buy>
            <product-intro slot="intro" type="BLA">
            <div class="product-info-content" slot="content">
                <div class="info-item-content">
                <h2 class="intro-title">为什么要办理ICP许可证</h2>
                <div class="ipc-intro">
                    <div class="ipc-intro-item" v-for="(item, index) in ipcIntro" :key="index">
                    <img :src="item.icon">
                    <p>{{item.text}}</p>
                    </div>
                </div>
                </div>
                <div class="info-item-content advantage-content">
                <h2 class="advantage-title">服务优势</h2>
                <div class="ipc-advantage">
                    <div class="ipc-advantage-item" v-for="(item, index) in ipcAdvantage" :key="index">
                    <img :src="item.icon">
                    <div class="ipc-advantage-item-text">
                        <h4>{{item.title}}</h4>
                        <p>{{item.des}}</p>
                    </div>
                    </div>
                </div>
                </div>
                <div class="info-item-content process-content">
                <h2 class="process-title">办理流程</h2>
                <img class="bla-process-icon" src="../assets/ipc_process.png">
                <div class="ipc-process">
                    <div class="ipc-process-item" v-for="(item, index) in ipcProcess" :key="index">
                    <h4><span>0{{index + 1}} </span>{{item.title}}</h4>
                    <p>{{item.des}}</p>
                    </div>
                </div>
                </div>
                <div class="info-item-content materials-content">
                <h2 class="materials-title">办理材料</h2>
                <div class="ipc-materials">
                    <div class="ipc-materials-left">
                    <p><span>1.</span> 营业执照（有效复印件）</p>
                    <p><span>3.</span> 依法经营电信业务承诺书</p>
                    <p><span>5.</span> 相关人员身份证明</p>
                    </div>
                    <img class="materials-icon" src="../assets/ipc_materials.png">
                    <div class="ipc-materials-right">
                    <p><span>2.</span> 域名备案信息</p>
                    <p><span>4.</span> 社保证明</p>
                    </div>
                </div>
                </div>
                <div class="info-item-content problem-content">
                <h2 class="problem-title">常见问题</h2>
                <img class="problem-icon" src="../assets/problem_icon.png">
                <div class="problem-item-content">
                    <div class="problem-item" v-for="(item, index) in ipcProblem" :key="index">
                    <h4>{{item.title}}</h4>
                    <p v-if="item.type === 'array'">
                        <span v-for="(desItem, num) in item.des" :key="num">{{desItem}}</span>
                    </p>
                    <p v-else>{{item.des}}</p>
                    </div>
                </div>
                </div>
            </div>
            </product-intro>
        </Layout>
    </div>
</template>

<script>
import Layout from '../components/Layout.vue';
import ProductBuy from '../components/ProductBuy.vue';
import ProductIntro from '../components/ProductIntro.vue';
import ipcIntro1 from '../assets/ipc_intro1.png';
import ipcIntro2 from '../assets/ipc_intro2.png';
import ipcIntro3 from '../assets/ipc_intro3.png';
import ipcIntro4 from '../assets/ipc_intro4.png';
import ipcService1 from '../assets/ipc_service1.png';
import ipcService2 from '../assets/ipc_service2.png';
import ipcService3 from '../assets/ipc_service3.png';
import blaIcon from '../assets/bla_icon.png';
import dacu from '../assets/dacu.png';

import DATA from '../common/data.js';
import client from '../common/client.js'
import {getUUID, base64Encode} from '../util/helper';

export default {
    components: {
        Layout,
        ProductBuy,
        ProductIntro
    },
    metaInfo: {
        title: 'ICP许可证_资质代办服务——百度智能云企业服务中心',
        meta: [
            {
                name: 'keywords',
                content: 'ICP经营性备案,ICP许可证',
            },
            {
                name: 'description',
                content: '保障企业资质安全，助力企业合规合法经营，向用户提供信息服务、行业经营必备的资质代办服务。',
            }
        ]
    },
    data () {
        return {
            baseInfo: {
                icon: blaIcon,
                title: 'ICP许可证',
                des: '经营性网站必备资质，助力企业合法合规经营',
                price: '1200元',
                unit: '',
                priceIcon: dacu,
                originPrice: '1500元/次',
                advantage: [
                '实时响应，专家服务',
                '一次性收费，无隐形费用',
                '服务流程全监管'
                ],
                serviceAdvantage: [
                '经营性网站必备资质',
                '助企业合法合规经营',
                '新品上架，限时优惠'
                ]
            },
            regionData: DATA.AREA,
            selectItem: {...DATA.AREA[0], price: 1200},
            selectListShow: false,
            ipcIntro: [
                {
                text: '行业准入必要前置',
                icon: ipcIntro1
                },
                {
                text: '合法合规重要凭证',
                icon: ipcIntro2
                },
                {
                text: '运营实力有效展现',
                icon: ipcIntro3
                },
                {
                text: '持续经营有力保障',
                icon: ipcIntro4
                }
            ],
            ipcAdvantage: [
                {
                icon: ipcService1,
                title: '操作简单',
                des: '应用智能化工具，简单操作流程，只需提交办理需求，专家顾问协助梳理，快速高效'
                },
                {
                icon: ipcService2,
                title: '专家全程一对一服务',
                des: '专家顾问全程一对一跟进服务，随时沟通，解决办理前后疑难问题，直至申请被受理'
                },
                {
                icon: ipcService3,
                title: '进度管理实时透明',
                des: '数据在线实时同步，申请进度随时掌握'
                }
            ],
            ipcProcess: [
                {
                title: '登记需求',
                des: '免费了解情况并选择您需要办理的增值电信业务类型'
                },
                {
                title: '专家服务',
                des: '专家顾问第一时间为您定制详细方案'
                },
                {
                title: '资料收集',
                des: '专家帮您在1-3个工作日完成材料收集与加工'
                },
                {
                title: '递交审核',
                des: '全套资料待您确认后，1个工作日内递交材料到行政单位'
                },
                {
                title: '核发证书',
                des: '进度实时同步，20-60个工作日完成审核并发放证书'
                }
            ],
            ipcProblem: [
                {
                title: '什么是ICP许可证',
                des: 'ICP许可证（全称：中华人民共和国电信与信息服务业务经营许可证）是指一般性经营性网站的主办者向当地区县申请的证书证明。根据《国务院互联网信息服务管理办法》（国务院292号令）的第三条规定：经营性ICP备案是指：企业通过网站从事有偿信息服务，根据相关部门规定需要办理进行经营性ICP备案，即ICP许可证。'
                },
                {
                title: '审批机构/年检/有效期',
                type: 'array',
                des: [
                    '1）企业注册地所在省、自治区、直辖市的通信管理局进行审批',
                    '2）ICP证年检是每年的1月4号—3月31号',
                    '3）ICP经营许可证使用年限为5年、5年后需要办理续期'
                ]
                },
                {
                title: '那些企业需要办理ICP许可证',
                des: '企业凡经营有偿信息发布网站，则需办理ICP许可证规范业务。即，包括互联网有偿信息服务的企业，均需要办理ICP证。具体来说，企业的主要经营业务，如果包括在线销售服务、在线点击支付、点击广告招商、会员收费等业务内容，则需要办理。特别需要指出，有会员收费、点击收费的业务内容，则强烈建议办理，以免造成不必要的风险。若未经审批擅自开展业务，涉嫌违规经营，由相关主管部门依法责令限期改正，给予罚款、责令关闭网站等行政处罚；构成犯罪的，依法追究刑事责任。'
                }
            ]
        }
    },
    methods: {
        onInputClick() {
            this.selectListShow = !this.selectListShow;
        },
        onSelectRegion(item) {
            this.selectItem = item;
            this.onInputClick();
            let identities = [{
                type: 'ICP',
                area: item.value
            }];
            client.getBlaPrice({identities}).then(res => {
                res = res.data.result;
                if (res && res.identities) {
                let identities = res.identities[0];
                Object.assign(this.baseInfo, {
                    price: identities.price,
                    originPrice: identities.originalPrice
                });
                this.selectItem.price = identities.price;
                }
            });
        },
        onBuy() {
            let product = {
                isDirectBuy: 1,
                frontendId: getUUID(),
                type: 'ICP',
                area: this.selectItem.value,
                price: this.selectItem.price,
                orderStatus: 'NOT_EXIST'
            };
            product = base64Encode(JSON.stringify([product]));
            window.open(`https://console.bce.baidu.com/bla/#/bla/order/confirm?product=${product}`);
        },
        onAsk() {
            window.open('http://webui.im.bdymkt.com/pageinfo.jsp?version=vip&admiuin=9371462&ltype=1&iscallback=1&page_templete_id=44084&is_message_sms=0&is_send_mail=0&action=acd&acd=1&type_code=2');
        }
    }
}
</script>

<style lang="less">
li {
    list-style-type: none;
}
.ipc-intro {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 810px;
    margin: 31px auto 46px;
    .ipc-intro-item {
        width: 145px;
        text-align: center;
        img {
            height: 94px;
            margin-bottom: 20px;
        }
        p {
            height: 24px;
            font-size: 17px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 24px;
            color: #191C3D;
            opacity: 0.8;
        }
    }
}
.ipc-advantage {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 930px;
    margin: 31px auto 32px;
    .ipc-advantage-item {
        width: 297px;
        height: 254px;
        position: relative;
        padding: 106px 43px 0;
        text-align: center;
        img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        }
        .ipc-advantage-item-text {
        z-index: 10;
        position: relative;
        }
        h4 {
        height: 25px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 25px;
        color: #191C3D;
        margin-bottom: 14px;
        }
        p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: #191C3D;
        opacity: 0.65;
        }
    }
}
.bla-process-icon {
    display: block;
    width: 817px;
    height: 63px;
    margin: 44px auto 12px;
}
.ipc-process {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    text-align: center;
    width: 768px;
    margin: 0 auto 30px;
    .ipc-process-item {
        width: 127px;
        h4 {
            height: 25px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 22px;
            color: #191C3D;
            span {
                color: #2468F2;
            }
        }
        p {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: #191C3D;
            opacity: 0.7;
        }
    }
}
.materials-content {
    .ipc-materials {
        display: flex;
        justify-content: center;
        margin-bottom: 48px;
        p {
        height: 25px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 22px;
        color: #191C3D;
        margin: 30px 0 32px;
        span {
            color: #2468F2;
        }
        }
        .ipc-materials-left {
            width: 225px;
        }
        .materials-icon {
            width: 324px;
            height: 197px;
        }
        .ipc-materials-right {
            margin-left: 65px;
        }
    }
}
</style>
